import { createStyles } from '@material-ui/core';
import type { Theme } from '@material-ui/core';

const styles = (theme: Theme) => {
  return createStyles({
    siteContainer: {
      '@global h1': {
        // color: theme.primary,
        marginBlockStart: '5px',
        marginBlockEnd: '5px'
      },

      '@global h2': {
        color: theme.primary,
        marginBlockStart: '5px',
        marginBlockEnd: '5px',
        fontWeight: 300
      },

      '@global h3': {
        color: theme.primary,
        marginBlockStart: '5px',
        marginBlockEnd: '5px',
        fontWeight: 300
      },

      '@global h4': {
        color: theme.primary,
        marginBlockStart: '5px',
        marginBlockEnd: '5px'
      },

      '@global h5': {
        color: theme.primary,
        marginBlockStart: '5px',
        marginBlockEnd: '5px'
      },

      '@global hr': {
        borderStyle: 'solid',
        borderColor: '#ddd',
        borderWidth: '1px 0 0',
        margin: '10px -10px'
      },

      //   // display: 'grid',
      //   // gridTemplateColumns: '1fr minmax(0, 1000px) 1fr',
      //   // MsGridColumns: 'minmax(min-content, 1fr) minmax(0px, 1000px) minmax(min-content, 1fr)',
      //   // gridTemplateRows: 'auto 50px',
      //   // MsGridRows: 'minmax(min-content, 1fr) 50px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      width: '100%',
      height: '100%',
      fontFamily: 'Nunito Sans, sans-serif'
    },

    msExplorer: {
      display: '-ms-grid',
      '-ms-grid-columns': '1fr',
      '-ms-grid-rows': 'auto auto auto'
    },

    contentContainer: {
      '-ms-grid-row': 2,
      flexGrow: 1
    }
  });
};

export default styles;
